import type { ReactNode } from 'react';
import React from 'react';

import { ClearSmall } from '@travel/icons/ui';

import Button from '../../Button';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import { ButtonVariantEnum, ButtonSize } from '../../../types/variants';

import styles from '../textField.module.scss';

/** Custom props */
export type TextfieldClearBtnProps = {
  /** The content of the component */
  children?: ReactNode;

  /** Function to handle clear button click */
  handleClearClick: () => void;

  /** Custom class to overwrite default styling if needed */
  className?: string;

  /** Controls the size of the textfield */
  size?: ButtonSize;

  /** Flag to indicate if the textfield is disabled */
  isDisabled?: boolean;
} & React.HTMLAttributes<HTMLButtonElement>;

export function ClearButton(props: TextfieldClearBtnProps) {
  const { className, size = ButtonSize.Medium, handleClearClick, isDisabled, ...rest } = props;

  return (
    <Button
      variant={ButtonVariantEnum.Ghost}
      onClick={handleClearClick}
      className={styles[toCamelCase('textField', 'clearButton')]}
      data-testid="textField-clear-button"
      isDisabled={isDisabled}
      {...rest}
    >
      <ClearSmall className={cx(styles[toCamelCase('textField', 'clearIcon', size)], className)} />
    </Button>
  );
}

export default ClearButton;
